export default __webpack_public_path__ + "static/media/collection-nft.f4d3045d.png";